import type { BffApiClient } from "@/app/api-client"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import type { QueryFunctionContext } from "@tanstack/react-query"

export const getCollectionOfferGroupsQueryParams = (
  apiClient: BffApiClient,
  collectionId: CollectionId,
) => {
  return {
    queryKey: ["collection", "offer-groups", collectionId] as const,
    queryFn: async ({
      pageParam,
    }: QueryFunctionContext<
      readonly ["collection", "offer-groups", CollectionId],
      string | undefined
    >) => {
      const response = await apiClient.api.collections[":id"][
        "offer-groups"
      ].$get({
        param: { id: collectionId },
        query: { cursor: pageParam as string | undefined },
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage: { cursor?: string }) => {
      return lastPage.cursor
    },
  }
}

export const getHighestCollectionOffersQueryParams = (
  apiClient: BffApiClient,
  collectionId: CollectionId,
) => {
  return {
    queryKey: ["collection", "offers", collectionId],
    queryFn: async () => {
      const response = await apiClient.api.collections[":id"].offers.$post({
        param: { id: collectionId },
        json: { size: 50 },
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
  }
}

export const getCollectionItemOffersQueryParams = (
  apiClient: BffApiClient,
  collectionId: CollectionId,
) => {
  return {
    queryKey: ["collection", "item-offers", collectionId] as const,
    queryFn: async ({
      pageParam,
    }: QueryFunctionContext<
      readonly ["collection", "item-offers", CollectionId],
      string | undefined
    >) => {
      const response = await apiClient.api.collections[":id"][
        "item-offers"
      ].$post({
        param: { id: collectionId },
        json: { cursor: pageParam as string | undefined, size: 30 },
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage: { cursor?: string }) => {
      return lastPage.cursor
    },
  }
}

export const getCollectionMyOffersQueryParams = (
  apiClient: BffApiClient,
  collectionId: CollectionId,
  maker: UnionAddress,
) => {
  return {
    queryKey: ["collection", "my-offers", collectionId, maker] as const,
    queryFn: async ({
      pageParam,
    }: QueryFunctionContext<
      readonly ["collection", "my-offers", CollectionId, UnionAddress],
      string | undefined
    >) => {
      const response = await apiClient.api.collections[":id"][
        "my-offers"
      ].$post({
        param: { id: collectionId },
        json: { maker, cursor: pageParam as string | undefined, size: 30 },
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage: { cursor?: string }) => {
      return lastPage.cursor
    },
  }
}
